var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 90,
    viewBox: "0 0 98 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1977 7.99998V40.48C74.6181 40.1572 73.0098 39.9964 71.3977 40C62.4946 40.0004 54.3226 44.927 50.1657 52.8H8.99766C5.46303 52.8 2.59766 49.9346 2.59766 46.4V7.99998C2.59766 4.46535 5.46303 1.59998 8.99766 1.59998H69.7977C73.3323 1.59998 76.1977 4.46535 76.1977 7.99998Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5975 40C57.6944 40.0004 49.5225 44.927 45.3655 52.8H50.1655C53.9383 45.6683 61.0393 40.907 69.0695 40.1248C68.2481 40.0419 67.423 40.0003 66.5975 40Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7976 1.59998H64.9976C68.5322 1.59998 71.3976 4.46535 71.3976 7.99998V40C73.0097 39.9964 74.618 40.1572 76.1976 40.48V7.99998C76.1976 4.46535 73.3322 1.59998 69.7976 1.59998Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1977 27.2V40.48C74.6181 40.1572 73.0098 39.9964 71.3977 40H2.59766V27.2H76.1977Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3975 27.2V40C73.0096 39.9964 74.6179 40.1572 76.1975 40.48V27.2H71.3975Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1977 9.59998H13.7977C12.0303 9.59998 10.5977 11.0327 10.5977 12.8V16C10.5977 17.7673 12.0303 19.2 13.7977 19.2H20.1977C21.965 19.2 23.3977 17.7673 23.3977 16V12.8C23.3977 11.0327 21.965 9.59998 20.1977 9.59998Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3975 64C95.3975 77.2548 84.6523 88 71.3975 88C58.1426 88 47.3975 77.2548 47.3975 64C47.3975 50.7452 58.1426 40 71.3975 40C73.0096 39.9964 74.6179 40.1572 76.1975 40.48C87.3707 42.7658 95.3948 52.5953 95.3975 64Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1976 40.48C74.618 40.1572 73.0097 39.9964 71.3976 40C70.6104 40 69.836 40.0512 69.0696 40.1248C69.8511 40.2031 70.6282 40.3217 71.3976 40.48C83.0264 42.8476 91.1788 53.359 90.5787 65.2112C89.9786 77.0634 80.8061 86.6975 68.9976 87.8784C69.788 87.9568 70.588 88 71.3976 88C83.7276 88.0124 94.061 78.6796 95.3002 66.412C96.5393 54.1443 88.281 42.9336 76.1976 40.48Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59756 22.4C3.48121 22.4 4.19756 21.6837 4.19756 20.8C4.19756 19.9164 3.48121 19.2 2.59756 19.2C1.7139 19.2 0.997559 19.9164 0.997559 20.8C0.997559 21.6837 1.7139 22.4 2.59756 22.4Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7592 54.7872L63.4792 73.0272L58.1256 67.6752C57.4978 67.0689 56.4999 67.0775 55.8827 67.6947C55.2655 68.3119 55.2568 69.3098 55.8632 69.9376L62.2632 76.3376C62.8543 76.9279 63.7999 76.9641 64.4344 76.4208L86.8344 57.2208C87.2935 56.8567 87.5169 56.2707 87.4166 55.6933C87.3162 55.116 86.9083 54.6396 86.3533 54.4517C85.7982 54.2638 85.1848 54.3944 84.7544 54.792L84.7592 54.7872Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1976 20.8C22.8485 20.8 24.9976 18.651 24.9976 16V12.8C24.9976 10.149 22.8485 8 20.1976 8H13.7976C11.1466 8 8.99756 10.149 8.99756 12.8V16C8.99756 18.651 11.1466 20.8 13.7976 20.8H20.1976ZM12.1976 16V12.8C12.1976 11.9163 12.9139 11.2 13.7976 11.2H20.1976C21.0812 11.2 21.7976 11.9163 21.7976 12.8V16C21.7976 16.8837 21.0812 17.6 20.1976 17.6H13.7976C12.9139 17.6 12.1976 16.8837 12.1976 16Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5976 12.8H66.5976C67.4812 12.8 68.1976 12.0836 68.1976 11.2C68.1976 10.3163 67.4812 9.59998 66.5976 9.59998H34.5976C33.7139 9.59998 32.9976 10.3163 32.9976 11.2C32.9976 12.0836 33.7139 12.8 34.5976 12.8Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5976 19.2H50.5976C51.4812 19.2 52.1976 18.4837 52.1976 17.6C52.1976 16.7163 51.4812 16 50.5976 16H34.5976C33.7139 16 32.9976 16.7163 32.9976 17.6C32.9976 18.4837 33.7139 19.2 34.5976 19.2Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7976 39.2432V8C77.7923 3.58391 74.2136 0.00528979 69.7976 0H8.99756C4.58147 0.00528979 1.00285 3.58391 0.997559 8V14.4C0.997559 15.2837 1.7139 16 2.59756 16C3.48121 16 4.19756 15.2837 4.19756 14.4V8C4.19756 5.34903 6.34659 3.2 8.99756 3.2H69.7976C72.4485 3.2 74.5976 5.34903 74.5976 8V25.6H2.59756C1.7139 25.6 0.997559 26.3163 0.997559 27.2V46.4C1.00285 50.8161 4.58147 54.3947 8.99756 54.4H47.6824C43.6698 64.2817 46.2041 75.6158 54.0432 82.8475C61.8823 90.0792 73.3836 91.6932 82.9104 86.8984C92.4372 82.1037 97.9932 71.9049 96.8554 61.3004C95.7177 50.6959 88.1246 41.9079 77.7976 39.2432ZM74.5976 38.6224C73.5366 38.481 72.4678 38.4067 71.3976 38.4H4.19756V28.8H74.5976V38.6224ZM8.99756 51.2C6.34659 51.2 4.19756 49.051 4.19756 46.4V41.6H59.0312C54.9683 43.8602 51.5925 47.1773 49.2616 51.2H8.99756ZM71.3976 86.4C59.0264 86.4 48.9976 76.3712 48.9976 64C48.9976 51.6288 59.0264 41.6 71.3976 41.6C83.7687 41.6 93.7976 51.6288 93.7976 64C93.7843 76.3657 83.7633 86.3868 71.3976 86.4Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.1c22cbe4da43b9408fa18646a5ae5ec1.svg";
export { ForwardRef as ReactComponent };